import { render, staticRenderFns } from "./CalendarEventModal.vue?vue&type=template&id=71e2fef5&scoped=true&"
import script from "./CalendarEventModal.vue?vue&type=script&lang=js&"
export * from "./CalendarEventModal.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventModal.vue?vue&type=style&index=0&id=71e2fef5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2fef5",
  null
  
)

export default component.exports